import { graphQuery, graphMutation } from '@services/commService';
import { updateUserBusinessUnits } from '@containers/Admin/shared/businessUnitService';

export const getStaffUserInformation = async (id) => {
  const query = `
    {
      userData(id: "${id}") {
        id
        roles
        firstName
        fullName
        lastName
        avatar
        email
        phone
        mfaStatus
        isMigratedToCognito
        userName
        status
        state
        experimentalFeatures
        businessUnits
        businessUnitsInfo {
          id
          name
        }
        mentorProperties {
          enableTimeTracking
        }
      }
    }
  `;
  const res = await graphQuery(query, true);
  return res.data;
};

export const sendStaffUserStatus = async (userId, state) => {
  const mutation = `
    mutation {
      createUserState(userId: "${userId}", state: ${state}){
          state
      }
    }
  `;
  return await graphMutation(mutation, {}, true);
};

export const sendStaffUserBusinessUnits = async (userId, businessUnits) => {
  return await updateUserBusinessUnits(userId, businessUnits);
};

// Admin reset password (generate temp password via API)
export const adminResetPassword = async (userId) => {
  const mutation = `
    mutation {
      adminForceResetUserPassword(userId: "${userId}") {
        temporaryPassword
        emailSent
        blockedReason
      }
    }
  `;
  try {
    const res = await graphMutation(mutation, {}, true);
    if (res.errors) {
      throw new Error(res.errors[0].message || 'Failed to reset password');
    }
    return res.data.adminForceResetUserPassword;
  } catch (err) {
    throw new Error(err.message || 'Failed to reset password');
  }
};

export const sendMentorEnableTimeTracking = async (userId, enableTimeTracking) => {
  const mutation = `
    mutation {
      updateMentorEnableTimeTracking(userId: "${userId}", enableTimeTracking: ${enableTimeTracking}){
          enableTimeTracking
      }
    }
  `;
  return await graphMutation(mutation, {}, true);
};

export const sendUserExperimentalFeatures = async (userId, experimentalFeatures) => {
  const mutation = `
    mutation {
      updateUserExperimentalFeatures(userId: "${userId}", experimentalFeatures: ${experimentalFeatures}) {
        experimentalFeatures
      }
    }
  `;
  return await graphMutation(mutation, {}, true);
};
